export default "__VITE_ASSET__BRVIjngu__"